import script from "./DeadlineChartTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineChartTable.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineChartTable.vue?vue&type=style&index=0&id=67372fd2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67372fd2"]])

export default __exports__